// extracted by mini-css-extract-plugin
export default {"guideModal":"ScenarioChallenge_guideModal__bIZnu","lexiIcon":"ScenarioChallenge_lexiIcon__mDX+P","speakerIcon":"ScenarioChallenge_speakerIcon__PTgB4"};